module.exports = __webpack_public_path__ + "static/how-it-works-step-4.0a27e32d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/how-it-works/how-it-works-step-4.png
// module id = 954
// module chunks = 214286880276331